export default __webpack_public_path__ + "static/media/akar-icons_shipping-box-01.f971498c.svg";